import { useEffect, useState } from 'react';
import { errorTypesText, validateInputOnBlur, validateInputOnInput, validationRules } from '../../../util/validation';
import { buildAnswersObject } from '../utils/feedbackUtils';
import deleteCookiesApi from '../../../client/deleteCookiesApi';

const useFeedbackModal = (
  handleOpenFeedbackModal,
  store,
  isStoreFeedback,
  triggerPushSurvey,
  handleGeneralFeedback
) => {
  const [hover, setHover] = useState(0);
  const [selectedExp, setSelectedExp] = useState(
    isStoreFeedback
      ? 'e5219cfe-17c5-4063-86e0-be320d754832'
      : triggerPushSurvey
        ? '00e93e3d-a616-4f11-9113-1d282b6dc39e'
        : 'default'
  );
  const [selectedState, setSelectedState] = useState(isStoreFeedback ? store.state : undefined);
  const [templateTypes, setTemplateTypes] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const [answersObj, setAnswersObj] = useState({});

  const handleBuildAnswersObj = (data) => {
    setAnswersObj(buildAnswersObject(data, isStoreFeedback, store));
  };

  const getTemplate = (id, version) => {
    const base_url = window.location.origin;
    fetch(base_url + `/wcs/resources/store/301/survey/template/${id}/${version}`, {
      credentials: 'omit',
    })
      .then((res) => {
        if (res.status === 401) {
          deleteCookiesApi();
        }
        return res.json();
      })
      .then((data) => {
        handleBuildAnswersObj(data.response);
        setSelectedTemplate(data.response);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  };

  const getDefaultTemplate = (templates) => {
    const defaultSiteId = templates.find((item) =>
      isStoreFeedback ? item.templateId === 'e5219cfe-17c5-4063-86e0-be320d754832' : item.templateId === ''
    );
    {
      defaultSiteId ? getTemplate(defaultSiteId.templateId, defaultSiteId.latestVersion) : setLoading(false);
    }
  };

  const handleSelectedExp = (val) => {
    setSelectedExp(val);
    setLoading(true);
    if (val != 'default') {
      const selected = templateTypes.find((item) => item.templateId === val);
      getTemplate(val, selected.latestVersion);
    } else {
      setLoading(false);
      setSelectedTemplate(undefined);
    }
  };

  useEffect(() => {
    const base_url = window.location.origin;

    if (setTemplateTypes !== null && !triggerPushSurvey) {
      fetch(base_url + '/wcs/resources/store/301/survey/template/feedback', {
        credentials: 'omit',
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.response) {
            setTemplateTypes(data.response.templates);
            getDefaultTemplate(data.response.templates);
          } else if (data.errors) {
            setError(true);
            setErrorMessage(data.errors[0].errorMessage);
          }
        })
        .catch((err) => {
          throw err;
        });
    } else if (triggerPushSurvey) {
      fetch(base_url + '/wcs/resources/store/301/survey/template/00e93e3d-a616-4f11-9113-1d282b6dc39e', {
        credentials: 'omit',
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.response) {
            handleBuildAnswersObj(data.response);
            setSelectedTemplate(data.response);
            setLoading(false);
          } else if (data.errors) {
            setError(true);
            setErrorMessage(data.errors[0].errorMessage);
          }
        })
        .catch((err) => {
          throw err;
        });
    }
  }, []);

  const handleInput = (val, id, type) => {
    const ansObj = { ...answersObj };
    const validation = validateInputOnInput(val, type);
    ansObj[id].value = validation.value;
    ansObj[id].valid = true;
    setAnswersObj(ansObj);
  };

  const handleBlur = (val, id, type, required) => {
    const ansObj = { ...answersObj };
    const validation = validateInputOnBlur(val, type, required);
    if (type !== 'stateDD') {
      ansObj[id].valid = validation.valid;
      ansObj[id].errorMsg = validation.errorMsg;
      setAnswersObj(ansObj);
    }
  };

  const handleSelectYoN = (e, id, val) => {
    e.preventDefault();
    const ansObj = { ...answersObj };
    ansObj[id].value = val;
    ansObj[id].valid = true;
    setAnswersObj(ansObj);
  };

  const handleResetFeedbackModal = () => {
    setHover(0);
    setSelectedExp('6aec15f7-f46e-4bca-8328-d8294a82679b');
    setSelectedState(undefined);
    setError(false);
    setSubmitSuccess(false);
    setAttemptedSubmit(false);
    handleOpenFeedbackModal();
  };

  const handleResetPushSurveyModal = () => {
    setHover(0);
    setSelectedState(undefined);
    setError(false);
    setSubmitSuccess(false);
    setAttemptedSubmit(false);
    handleGeneralFeedback();
  };

  const handleHover = (idx) => {
    setHover(idx);
  };

  const liveChatOnClick = () => {
    window.openChatButtonClick();
    handleOpenFeedbackModal();
  };

  const handleSelectState = (val) => {
    setSelectedState(val);
  };

  const handleSubmitFeedback = (e) => {
    e.preventDefault();
    setAttemptedSubmit(true);
    const feedbackAnsObj = {
      userMetadata: {
        QuantumMetricSessionID: '',
        mPulseSessionID: '',
      },
      answers: {},
    };

    let everthingIsValid = true;

    // get quantumMetricUser stuff
    if (document.cookie.length != 0) {
      const cookiesArray = document.cookie.split(';');
      const match = cookiesArray.filter((s) => s.includes('QuantumMetricSessionID'));
      const userID = match[0]?.split('=', 2)[1];
      feedbackAnsObj.userMetadata.QuantumMetricSessionID = userID ? userID : '';

      //WWW-19179 - get mPulse Session ID
      const mPulseSIDStr = cookiesArray.filter((t) => t.includes('RT'));
      const mPulseSID_RT = mPulseSIDStr[0];
      const splitStr = mPulseSID_RT?.split('&');
      const findSI = splitStr?.find((u) => u.startsWith('si'));
      const mPulseSID = findSI?.split('=', 2)[1];
      feedbackAnsObj.userMetadata.mPulseSessionID = mPulseSID ? mPulseSID : '';
      //WWW-19179 - get mPulse Session ID
    }

    // build answer object
    // some small validation can go here maybe who knows
    feedbackAnsObj['templateId'] = selectedExp;
    feedbackAnsObj['version'] = selectedTemplate.version;
    // console.log(answersObj)
    Object.keys(answersObj).forEach((q) => {
      if (
        (answersObj[q].required === true && (answersObj[q].value === '' || answersObj[q].value === 0)) ||
        (answersObj[q].name === 'email' && !answersObj[q].valid)
      ) {
        // Skip validation for follow-up questions that are not currently shown.
        // If this question has a parent, only validate if the parent's answer matches the followup trigger.
        if (answersObj[q].parentId) {
          const parent = answersObj[answersObj[q].parentId];
          if (parent && parent.value !== parent.followupAnswer) {
            // Parent answer does not trigger this follow-up, so skip validation.
            return;
          }
        }

        const ansObj = { ...answersObj };
        ansObj[q].valid = false;
        const validationName = validationRules[answersObj[q].name]
          ? answersObj[q].name
          : validationRules.aliases[answersObj[q].name];
        const rule = validationRules[validationName];
        ansObj[q].errorMsg = rule.errorMsg.required;
        setAnswersObj(ansObj);
        if (everthingIsValid) {
          const id = answersObj[q].id;
          const el = document.querySelector(`#feedback_form_body form #feedback_${id}`);
          if (el) {
            // use scrollIntoViewIfNeeded if available, otherwise use scrollIntoView
            if (el.scrollIntoViewIfNeeded) {
              el.scrollIntoViewIfNeeded();
            } else {
              el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        }
        everthingIsValid = false;
      }
      feedbackAnsObj.answers[q] = answersObj[q].value;
    });

    const base_url = window.location.origin;
    // /wcs/resources/store/301/survey
    if (everthingIsValid) {
      setLoading(true);
      fetch(base_url + '/wcs/resources/store/301/survey', {
        method: 'POST',
        credentials: 'omit',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedbackAnsObj),
      })
        .then((res) => {
          setLoading(false);
          if (res.status === 200) {
            setSubmitSuccess(true);
          } else {
            setError(true);
          }
        })
        .catch((err) => {
          setLoading(false);
          setError(true);
          throw err;
        });
    }
  };

  return {
    hover,
    selectedExp,
    selectedState,
    templateTypes,
    selectedTemplate,
    loading,
    error,
    errorMessage,
    submitSuccess,
    attemptedSubmit,
    answersObj,
    handleSelectedExp,
    handleInput,
    handleBlur,
    handleSelectYoN,
    handleResetFeedbackModal,
    handleHover,
    handleSelectState,
    handleSubmitFeedback,
    handleResetPushSurveyModal,
    liveChatOnClick,
  };
};

export default useFeedbackModal;
